import React from "react";
import { Wrapper } from "./player.styles";

const Player = ({ children }) => {
  return (
    <Wrapper>
      <div id="player-root" />
      {children}
    </Wrapper>
  );
};

export default Player;
